<template>
  <el-form
    ref="ruleFormRef"
    class="insured-dialog-form account-person-form account-person-form--split"
    label-position="top"
    :rules="rules"
    :model="values"
    @submit.prevent
  >
    <div class="account-person-form__main">
      <div class="account-person-form__layout">
        <div class="account-person-form__col">
          <h3 class="account-person-form__title">{{ $t("commonIdCard") }}</h3>
          <div class="account-person-form__id-block">
            <div class="account-person-form__id-row">
              <el-form-item
                class="account-person-form__pin-item account-person-form__pin-item--data"
                :label="$t('searchPin')"
                prop="pin"
              >
                <el-input
                  v-model="values.pin"
                  maxlength="7"
                  class="uppercase-input"
                  :disabled="identityLocked"
                  @update:model-value="syncSearchField('pin', $event)"
                />
              </el-form-item>
              <el-form-item class="account-person-form__doc-item account-person-form__doc-item--data" :label="$t('searchDocSeriesNumber')">
                <div
                  class="account-person-form__doc-combo"
                  :class="{ 'account-person-form__doc-combo--disabled': identityLocked }"
                >
                  <el-input
                    v-model="values.docSeries"
                    maxlength="3"
                    class="account-person-form__doc-series"
                    placeholder="AA"
                    :disabled="identityLocked"
                    @update:model-value="syncSearchField('docSeries', $event)"
                  />
                  <span class="account-person-form__doc-divider" aria-hidden="true" />
                  <el-input
                    v-model="values.docNumber"
                    class="account-person-form__doc-number"
                    :placeholder="$t('commonNumber')"
                    :disabled="identityLocked"
                    @update:model-value="syncSearchField('docNumber', $event)"
                  />
                </div>
              </el-form-item>
            </div>
          </div>

          <h3 class="account-person-form__title account-person-form__title--gap">{{ $t("commonGeneralInfo") }}</h3>
          <div class="account-person-form__row account-person-form__row--3">
            <el-form-item :label="$t('commonLastName')" prop="lastName">
              <el-input v-model="values.lastName" :disabled="identityLocked" />
            </el-form-item>
            <el-form-item :label="$t('commonName')" prop="firstName">
              <el-input v-model="values.firstName" :disabled="identityLocked" />
            </el-form-item>
            <el-form-item :label="$t('commonMiddleName')" prop="middleName">
              <el-input v-model="values.middleName" :disabled="identityLocked" />
            </el-form-item>
          </div>
          <div class="account-person-form__row account-person-form__row--2">
            <el-form-item :label="$t('commonSex')" prop="sex">
              <el-select v-model="values.sex" :placeholder="$t('commonSelect')" :disabled="identityLocked">
                <el-option
                  v-for="item in sexOptions"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('commonBirthDate')" prop="dob">
              <el-date-picker
                v-model="values.dob"
                style="width: 100%"
                type="date"
                format="DD.MM.YYYY"
                placeholder="dd.mm.yyyy"
                :disabled="identityLocked"
              />
            </el-form-item>
          </div>
        </div>

        <div class="account-person-form__col account-person-form__col--right">
          <h3 class="account-person-form__title">{{ $t("commonAddress") }}</h3>
          <el-form-item class="account-person-form__address-line" :label="$t('commonAddress')">
            <el-input v-model="values.address" />
          </el-form-item>
          <el-form-item class="account-person-form__zip-item" :label="$t('commonPostalCode')">
            <el-input v-model="values.zip" maxlength="10" />
          </el-form-item>

          <h3 class="account-person-form__title account-person-form__title--gap">{{ $t("commonContact") }}</h3>
          <div class="account-person-form__row account-person-form__row--2">
            <el-form-item :label="$t('commonMobilePhone')" prop="phone">
              <AzPhoneInput v-model="values.phone" />
            </el-form-item>
            <el-form-item label="Email">
              <el-input v-model="values.email" placeholder="email@example.com" />
            </el-form-item>
          </div>
        </div>
      </div>

        <section class="account-insurance-panel">
          <h3 class="account-person-form__title">{{ $t("commonInsurance") }}</h3>
          <div class="account-person-form__row account-person-form__row--insurance">
            <el-form-item :label="$t('commonProgram')" prop="groupId">
              <el-select v-model="values.groupId" :placeholder="$t('commonSelect')">
                <el-option
                  v-for="item in groupOptions"
                  :key="item.groupId"
                  :label="item.groupName"
                  :value="item.groupId"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('commonStatus')" prop="statusId">
              <el-select v-model="values.statusId" :placeholder="$t('commonSelect')">
                <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('mainInsured')"
              prop="familySearch"
              :required="values.statusId === false || values.statusId === 0"
            >
              <el-input
                v-model="values.familySearch"
                :disabled="values.statusId !== false && values.statusId !== 0"
                class="uppercase-input"
                :placeholder="$t('commonPinOrCard')"
              />
            </el-form-item>
          </div>
          <div class="account-person-form__row account-person-form__row--dates">
            <el-form-item :label="$t('insuredAcceptDate')" prop="startDate">
              <el-date-picker
                v-model="values.startDate"
                :disabled-date="disabledDate"
                type="date"
                format="DD.MM.YYYY"
                placeholder="dd.mm.yyyy"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :label="$t('commonNotes')">
              <el-input v-model="values.descr" :placeholder="$t('commonExtraNotes')" />
            </el-form-item>
          </div>
        </section>
    </div>

    <div class="insured-dialog-footer">
      <button type="button" class="insured-dialog-btn insured-dialog-btn--muted" @click="close">
        {{ $t("commonCancel") }}
      </button>
      <button type="button" class="insured-dialog-btn insured-dialog-btn--primary" @click="submitForm">
        {{ $t("commonInsert") }}
      </button>
    </div>
  </el-form>
</template>

<script>
import { getPolicyId } from "@/project/Source/routes";

import Source from "../../Source/claim.js";
import CryptoJS from "crypto-js";
import {
  normalizeAzMobilePhone,
} from "../../Source/helper.js";
import { notifyRequestSuccess } from "@/project/Source/utils.js";
import AzPhoneInput from "../../Global/Components/AzPhoneInput.vue";

export default {
  name: "InsuredDialog",
  components: {
    AzPhoneInput,
  },
  props: {
    cancel: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => ({}),
    },
    policyId: {
      type: [Number, String],
      default: null,
    },
    searchDraft: {
      type: Object,
      default: () => ({
        pin: "",
        docSeries: "",
        docNumber: "",
        searchMode: "asan",
        loading: false,
      }),
    },
  },
  emits: ["custom-event", "custom-insert", "update:search-draft"],
  data() {
    return {
      values: {
        phone: "",
        pin: "",
        docSeries: "",
        docNumber: "",
        zip: "",
        email: "",
      },
      groupOptions: [],
      statusOptions: [],
      sexOptions: [],
      identityLocked: true,
      rules: {
        phone: [{ required: true, validator: this.phoneCheck, trigger: "change" }],
        firstName: [{ required: true, message: "Mütləq sahə", trigger: "change" }],
        pin: [{ validator: this.pinCheck, trigger: "change" }],
        startDate: [{ required: true, message: "Mütləq sahə", trigger: "change" }],
        dob: [{ required: true, message: "Mütləq sahə", trigger: "change" }],
        familySearch: [{ validator: this.isValid, trigger: "change" }],
        groupId: [{ required: true, message: "Mütləq sahə", trigger: "change" }],
        middleName: [{ required: true, message: "Mütləq sahə", trigger: "change" }],
        sex: [{ required: true, message: "Mütləq sahə", trigger: "change" }],
        lastName: [{ required: true, message: "Mütləq sahə", trigger: "change" }],
        statusId: [{ required: true, message: "Mütləq sahə", trigger: "change" }],
      },
    };
  },
  computed: {
    searchMode() {
      return this.searchDraft?.searchMode || "asan";
    },
  },
  watch: {
    searchDraft: {
      deep: true,
      immediate: true,
      handler(draft) {
        if (!draft) return;
        this.values.pin = draft.pin || "";
        this.values.docSeries = draft.docSeries || "";
        this.values.docNumber = draft.docNumber || "";
        this.identityLocked = (draft.searchMode || "asan") === "asan";
      },
    },
    "values.statusId"(val) {
      if (val !== false && val !== 0) {
        this.values.familySearch = "";
      }
      if (this.$refs.ruleFormRef) {
        this.$nextTick(() => {
          this.$refs.ruleFormRef.validateField("familySearch", () => {});
        });
      }
    },
  },
  mounted() {
    const effectivePolicyId =
      this.policyId ||
      getPolicyId(this.$route) ||
      (sessionStorage.getItem("policy") ? JSON.parse(sessionStorage.getItem("policy")) : null);

    if (effectivePolicyId) {
      const data = {
        id: effectivePolicyId,
        requestCorrelationId: "string",
      };
      Source.Groups(data).then((response) => {
        this.groupOptions = response.data.data;
      });
    }
    this.statusOptions = [
      { value: true, text: "işçi" },
      { value: false, text: "ailə üzvü" },
    ];
    this.sexOptions = [
      { value: "m", text: "kişi" },
      { value: "f", text: "qadın" },
    ];
  },
  methods: {
    syncSearchField(field, value) {
      this.$emit("update:search-draft", {
        ...this.searchDraft,
        [field]: value,
      });
    },
    searchPerson() {
      this.$emit("update:search-draft", {
        ...this.searchDraft,
        loading: true,
      });
      setTimeout(() => {
        this.$emit("update:search-draft", {
          ...this.searchDraft,
          loading: false,
        });
      }, 600);
    },
    submitForm() {
      this.$refs.ruleFormRef
        .validate()
        .then(() => {
          const realDate = this.values.dob;
          const year = realDate.getFullYear();
          const month = ("0" + (realDate.getMonth() + 1)).slice(-2);
          const day = ("0" + realDate.getDate()).slice(-2);
          const hours = ("0" + realDate.getHours()).slice(-2);
          const minutes = ("0" + realDate.getUTCMinutes()).slice(-2);
          const seconds = ("0" + realDate.getUTCSeconds()).slice(-2);
          const milliseconds = ("00" + realDate.getUTCMilliseconds()).slice(-3);
          const appDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;

          let userId = 1;
          try {
            const rawUser = window.localStorage.getItem("user");
            if (rawUser) {
              userId = JSON.parse(CryptoJS.AES.decrypt(rawUser, "secret_key").toString(CryptoJS.enc.Utf8)).userId;
            }
          } catch (e) {
            userId = 1;
          }

          const policyIdVal = Number(
            this.policyId ||
            (sessionStorage.getItem("policy") ? JSON.parse(sessionStorage.getItem("policy")) : 0) ||
            getPolicyId(this.$route) ||
            0
          );

          const groupObj = (this.groupOptions || []).find((g) => Number(g.groupId || g.id) === Number(this.values.groupId));
          const groupNameVal = groupObj ? (groupObj.groupName || groupObj.name) : null;

          const bulkPayload = {
            requestCorrelationId: "string",
            policyId: policyIdVal,
            operType: 1, // Yeni sığortalı
            groupId: this.values.groupId,
            effectiveDate: this.values.startDate ? new Date(this.values.startDate) : new Date(),
            descr: this.values.descr || "Yeni sığortalı əlavəsi",
            createUser: userId || 1,
            items: [
              {
                cardId: null,
                cardFullNumber: null,
                pin: this.values.pin,
                firstName: this.values.firstName,
                lastName: this.values.lastName,
                middleName: this.values.middleName,
                dob: appDate ? new Date(appDate) : null,
                sex: this.values.sex,
                phone: this.normalizePhone(this.values.phone),
                address: this.values.address,
                isEmployee: this.values.statusId === true || this.values.statusId === 1,
                vip: this.values.vip || false,
                oldGroupId: null,
                oldGroupName: null,
                newGroupId: this.values.groupId,
                newGroupName: groupNameVal,
                startDate: this.values.startDate ? new Date(this.values.startDate) : new Date(),
                endDate: null,
              },
            ],
          };

          Source.AccountRequestBulkInsert(bulkPayload).then(() => {
            notifyRequestSuccess({
              count: 1,
              policyId: policyIdVal,
              isBulk: true,
            });
            this.$emit("custom-insert", 1);
          });
        })
        .catch((error) => {
          console.log("Invalid fields:", error);
        });
    },
    normalizePhone(value) {
      return normalizeAzMobilePhone(value);
    },
    close() {
      this.$emit("custom-event", 0);
    },
    disabledDate(time) {
      const dayInMillis = 24 * 60 * 60 * 1000;
      return time.getTime() <= new Date() - dayInMillis;
    },
    phoneCheck(rule, value, callback) {
      if (!value) {
        return callback(new Error("Mütləq sahə"));
      }
      setTimeout(() => {
        const phone = this.normalizePhone(this.values.phone);
        const rightSecond = phone[3] + phone[4];
        const validPrefix =
          rightSecond === "50" ||
          rightSecond === "55" ||
          rightSecond === "70" ||
          rightSecond === "77" ||
          rightSecond === "10" ||
          rightSecond === "99";
        if (phone.length === 12 && validPrefix) {
          return callback();
        }
        return callback(new Error("Səhf məlumat"));
      }, 300);
    },
    pinCheck(rule, value, callback) {
      if (this.searchMode === "manual") {
        return callback();
      }
      if (!value) {
        return callback(new Error("Mütləq sahə"));
      }
      return callback();
    },
    isValid(rule, value, callback) {
      if (this.values.statusId === false || this.values.statusId === 0) {
        if (!value || !value.toString().trim()) {
          return callback(new Error(this.$t ? this.$t("commonRequiredField") : "Mütləq sahə"));
        }
      }
      return callback();
    },
  },
};
</script>

<style scoped>
.uppercase-input :deep(.el-input__inner) {
  text-transform: uppercase;
}
</style>
